import Vue from 'vue';
import Component from 'vue-class-component';
import FormErrorMap from '@/store/models/FormErrorMap';
import IOption from '@/store/models/IOption';

declare module 'vue/types/vue' {
	interface Vue {
		// validateFormData(interviewForm: InterviewForm, formData: any, isCsvScreen: boolean): boolean;
		claimantAffirmationLabel: string;
		agentAffirmation1Label: string;
		agentAffirmation2Label: string;
		agentAffirmation3Label: string;
		agentAffirmation4Label: string;
		getEmailRegex(): RegExp;
		getFormDataKey(key: string): any;
		getDropdownOptions(dropdownKey: string): IOption[];
		isStringNullOrEmpty(str: string): boolean;
		dateToString(date: Date): string;
		getDeathDateCutoff(): Date;
	}
}

@Component
export default class Mixins extends Vue {
	public claimantAffirmationLabel: string = 'I verify and affirm under penalty of perjury that the statements made in the claim to the best of my knowledge and belief, are true and correct. I acknowledge that any false statement contained herein may be punishable under the laws of New York State, and complete in accordance with the laws of the State of New York.';
	public agentAffirmation1Label: string = 'I verify and affirm, under penalty of perjury, that the statements made in the claim to the best of my knowledge and belief, are true and correct.';
	public agentAffirmation2Label: string = 'And I have been lawfully appointed to file this registration.';
	public agentAffirmation3Label: string = 'I have read and know the contents of this registration.';
	public agentAffirmation4Label: string = 'I believe the same to be true. I acknowledge that any false statement contained herein may be punishable under the laws of the State of New York State.';

	public get isLoggedIn(): boolean { return this.$store.state.AuthModule.token != null }
	public get userName(): string { return this.$store.state.AuthModule.name }
	public get logoutUrl(): string { return process.env.VUE_APP_LOGOUT_URL }
	public get loginUrl(): string { return process.env.VUE_APP_LOGIN_URL }
	public get apiUrl(): string { return process.env.VUE_APP_API_URL }
	public get portalUrl(): string { return process.env.VUE_APP_PORTAL_URL }
	public get registerUrl(): string { return process.env.VUE_APP_NYGOV_REGISTER_URL }
	public get forgotUsernameUrl(): string { return process.env.VUE_APP_NYGOV_FORGOT_USERNAME_URL }
	public get forgotPasswordUrl(): string { return process.env.VUE_APP_NYGOV_FORGOT_PASSWORD_URL }
	public get deathDateCutoff(): string { return process.env.VUE_APP_DEATHDATECUTOFF }
	public get formErrorMap(): FormErrorMap { return this.$store.getters['InterviewModule/formErrorMap'] }

	public getDeathDateCutoff(): Date { return new Date(Date.parse(this.deathDateCutoff)) }

	public getFormDataKey(key: string): any {
		let context = this.$store.getters['InterviewModule/formData'];
		if (key) {
			const keyParts = key.split('.');
			for (let i = 0; i < keyParts.length; i++) {
				if (context[keyParts[i]] !== undefined) context = context[keyParts[i]];
				else context = '';
				if (context === null) return '';
			}
		}
		return context;
	}

	public getEmailRegex(): RegExp {
		return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	}

	public getDropdownOptions(dropdownKey: string): IOption[] {
		const dropdowns = this.$store.getters['InterviewModule/dropdowns'];
		if (dropdowns && dropdowns[dropdownKey]) return dropdowns[dropdownKey];
		return [];
	}

	public getErrorForField(id: string) {
		if (Object.keys(this.formErrorMap).length > 0) {
			for (const fieldId in this.formErrorMap) {
				if (fieldId === id) {
					return this.formErrorMap[fieldId];
				}
			}
		}
		return null;
	}

	public isStringNullOrEmpty(str: string): boolean {
		return str === undefined || str === null || str === '';
	}

	public dateToString(date: Date): string {
		const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
		return `${monthNames[date.getMonth()]} ${date.getDate() + 1}, ${date.getFullYear()}`;
	};
}
